export default __webpack_public_path__ + "static/media/Music_note.b92563ce.svg";